import React from "react";
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '@/config/msalConfig';
import { AuthProvider } from "./Auth";
import Language from "@/components/Language";
import { useTranslation } from "react-i18next";
import { Toaster } from "sonner";

const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

const Contexts: React.FC<any> = ({ children }) => {
  const { i18n } = useTranslation();
  const languages = Object.keys(i18n.services.resourceStore.data);

  return (
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <Toaster richColors />
        <div className="flex gap-4 items-start absolute top-5 right-8">
          <Language languages={languages} />
        </div>
        {children}
      </AuthProvider>
    </MsalProvider>
  );
};

export default Contexts;